var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.707 18.707c-.36.36-.928.388-1.32.083l-.094-.083-6-6c-.36-.36-.388-.928-.083-1.32l.083-.094 6-6c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094L10.415 12l5.292 5.293c.36.36.388.928.083 1.32l-.083.094z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLeft);
export default __webpack_public_path__ + "static/media/circle-left.6ef2dbf3a25295b5c7d53e7382162519.svg";
export { ForwardRef as ReactComponent };